import React, { createContext, useContext, useState } from 'react';
import Modal, { ModalCloseButton } from '../shared/modals/Modal';

const MessageContext = createContext();

export const useMessage = () => useContext(MessageContext);

export const MessageProvider = ({ children }) => {
  const [messageState, setMessageState] = useState({
    visible: false,
    title: '',
    message: '',
    resolve: null,
  });

  const showMessage = (message, title) => {
    return new Promise((resolve) => {
      setMessageState({ visible: true,
                        title,
                        message,
                        resolve,
                      });
    });
  };

  const closeMessage = () => {
    setMessageState((previous) => ({ ...previous, visible: false }));
  };

  return (
    <MessageContext.Provider value={showMessage}>
      {children}
      {messageState.visible && (
        <Modal isOpen={true} onClose={closeMessage}>
          <div className="modal">
            <div className='modal__header'>
              <h3 className='margin-none'>{messageState.title}</h3>
              <ModalCloseButton
                onClick={closeMessage}
                label="Close message modal"
              />
            </div>

            <div className="modal__body">
              <p>{messageState.message}</p>
            </div>

            <div className="modal__footer">
              <button className="btn secondary"
                      onClick={closeMessage}>
                Close
              </button>
            </div>
          </div>
        </Modal>
      )}
    </MessageContext.Provider>
  );
};
